"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManualFlowService = void 0;
class ManualFlowService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Add a new manual stage
     * @param requestBody
     * @returns ManualStageResponse
     * @throws ApiError
     */
    createManualStage(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/manual-workflow/stage',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get all manual stages
     * @returns ManualStagesResponse
     * @throws ApiError
     */
    getManualStages() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/manual-workflow/stage',
        });
    }
    /**
     * Get manual stage by id
     * @param id
     * @returns ManualStageResponse
     * @throws ApiError
     */
    getManualStage(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/manual-workflow/stage/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update manual stage
     * @param id
     * @param requestBody
     * @returns ManualStageResponse
     * @throws ApiError
     */
    updateManualStage(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/manual-workflow/stage/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * delete manual stage
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    deleteManualStage(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/manual-workflow/stage/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Add a new manual workflow
     * @param requestBody
     * @returns ManualWorkflowResponse
     * @throws ApiError
     */
    createManualWorkflow(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/manual-workflow',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get all manual workflows
     * @returns ManualWorkflowsResponse
     * @throws ApiError
     */
    getManualWorkflows() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/manual-workflow',
        });
    }
    /**
     * Get manual workflow by id
     * @param id
     * @returns ManualWorkflowResponse
     * @throws ApiError
     */
    getManualWorkflow(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/manual-workflow/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update manual workflow
     * @param id
     * @param requestBody
     * @returns ManualWorkflowResponse
     * @throws ApiError
     */
    updateManualWorkflow(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/manual-workflow/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * delete manual workflow
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    deleteManualWorkflow(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/manual-workflow/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Create a new manual template
     * @param flowId
     * @param requestBody
     * @returns ManualTemplateResponse
     * @throws ApiError
     */
    createManualTemplate(flowId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/manual-workflow/{flowId}/template',
            path: {
                'flowId': flowId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get all manual templates in workflow
     * @param flowId
     * @returns ManualTemplatesResponse
     * @throws ApiError
     */
    getManualWorkflowTemplates(flowId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/manual-workflow/{flowId}/template',
            path: {
                'flowId': flowId,
            },
        });
    }
    /**
     * Get manual template
     * @param flowId
     * @param id
     * @returns ManualTemplateResponse
     * @throws ApiError
     */
    getManualTemplate(flowId, id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/manual-workflow/{flowId}/template/{id}',
            path: {
                'flowId': flowId,
                'id': id,
            },
        });
    }
    /**
     * update manual template
     * @param flowId
     * @param id
     * @param requestBody
     * @returns ManualTemplateResponse
     * @throws ApiError
     */
    updateManualTemplate(flowId, id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/manual-workflow/{flowId}/template/{id}',
            path: {
                'flowId': flowId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete manual template
     * @param flowId
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    deleteManualTemplate(flowId, id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/manual-workflow/{flowId}/template/{id}',
            path: {
                'flowId': flowId,
                'id': id,
            },
        });
    }
    /**
     * Add manual stage to workflow
     * @param flowId
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    addManualWorkflowStage(flowId, id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/manual-workflow/{flowId}/stage/{id}',
            path: {
                'flowId': flowId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update workflow manual stage
     * @param flowId
     * @param id
     * @param requestBody
     * @returns ManualWorkflowStageResponse
     * @throws ApiError
     */
    updateManualWorkflowStage(flowId, id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/manual-workflow/{flowId}/stage/{id}',
            path: {
                'flowId': flowId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * delete manual stage from workflow
     * @param flowId
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    deleteManualWorkflowStage(flowId, id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/manual-workflow/{flowId}/stage/{id}',
            path: {
                'flowId': flowId,
                'id': id,
            },
        });
    }
    /**
     * Get all manual stages in workflow
     * @param flowId
     * @returns ManualWorkflowStagesResponse
     * @throws ApiError
     */
    getManualWorkflowStages(flowId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/manual-workflow/{flowId}/stage',
            path: {
                'flowId': flowId,
            },
        });
    }
    /**
     * Duplicate manual workflow with its stages and templates
     * @param id
     * @param requestBody
     * @returns ManualWorkflowResponse
     * @throws ApiError
     */
    duplicateManualWorkflow(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/manual-workflow/{id}/duplicate',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get allowed mandatory deployment fields for manual stages
     * @returns MandatoryFieldsResponse
     * @throws ApiError
     */
    getAllowedMandatoryFields() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/manual-workflow/mandatory-fields/allowed',
        });
    }
}
exports.ManualFlowService = ManualFlowService;
